import isBase64SrcImageUtil from 'components/Image/utils/is-base-64'
import isFromTrainingCdnSrcImageUtil from 'components/Image/utils/is-from-training-cdn-src'

export default function isExternalSrcImageUtil (src) {
  if (!src) {
    return false
  }
  if (isBase64SrcImageUtil(src)) {
    return false
  }
  return (
    (
      src.startsWith('http') ||
      src.startsWith('//')
    ) && (
      !src.includes('cdn.gymaholic.co') &&
      !isFromTrainingCdnSrcImageUtil(src)
    )
  )
}
